import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHospitalLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M15 2C16.1046 2 17 2.89543 17 4V9H19C20.1046 9 21 9.89543 21 11V20.9C21 21.5075 20.5075 22 19.9 22H4.1C3.49249 22 3 21.5075 3 20.9V4C3 2.89543 3.89543 2 5 2H15ZM15 4H5V20H7V17C7 15.3431 8.34315 14 10 14C11.6569 14 13 15.3431 13 17V20H15V4ZM19 11H17V20H19V11ZM10 16C9.48717 16 9.06449 16.386 9.00673 16.8834L9 17V20H11V17C11 16.4477 10.5523 16 10 16ZM10 6C10.5523 6 11 6.44772 11 7V8H12C12.5523 8 13 8.44772 13 9C13 9.55228 12.5523 10 12 10H11V11C11 11.5523 10.5523 12 10 12C9.44772 12 9 11.5523 9 11V10H8C7.44772 10 7 9.55228 7 9C7 8.44772 7.44772 8 8 8H9V7C9 6.44772 9.44772 6 10 6Z" })
});
export default SvgHospitalLine;
